// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Hallmark · genre: modern-minimal · macrostructure: Marquee Hero · theme: custom
 * paper: oklch(98% 0.010 250) · accent: oklch(60% 0.15 250)
 * display: Inter · body: Inter · axes: light / geometric-sans / cool
 * studied: no · context: inferred · v1.1.0
 */
.Homepage_homepage__qOb6- {
  width: 100%;
  overflow-x: clip;
}

/* ─── Shared section typography ─── */
.Homepage_section-title__MKa30 {
  font-size: clamp(2rem, 4vw + 1rem, 3rem);
  font-weight: 600;
  color: var(--color-ink);
  text-align: center;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.Homepage_section-subtitle__v6H8o {
  font-size: 1.125rem;
  color: var(--color-ink-2);
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ═══════════════════════════════════════════════════════
   SECTION 1: HERO
   ═══════════════════════════════════════════════════════ */
.Homepage_hero__8g5F3 {
  position: relative;
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-paper);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  padding-top: var(--space-4xl);
}
.Homepage_hero__overlay__RO0t1 {
  position: absolute;
  inset: 0;
  /* 
    Reduced opacity to show more of the image, 
    while still keeping enough contrast for the text.
  */
  background-color: var(--color-paper);
  opacity: 0.7;
  z-index: 1;
}
.Homepage_hero__content__5J5M7 {
  position: relative;
  z-index: 2;
  max-width: 880px;
  padding: 120px 24px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-xl);
}
.Homepage_hero__badge__DxPes {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: var(--space-sm);
}
.Homepage_hero__badge-logo__L\\+0bg {
  height: 48px;
  /* Removed brightness invert so logo shows in its original colors on white paper */
}
.Homepage_hero__title__gCViv {
  font-size: clamp(3rem, 6vw + 1rem, 5rem);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.04em;
  color: var(--color-ink);
  text-shadow: 0 4px 20px rgba(255, 255, 255, 0.8), 0 0 40px rgba(255, 255, 255, 0.6);
}
.Homepage_hero__subtitle__7BKto {
  font-size: 1.25rem;
  line-height: 1.6;
  color: var(--color-ink-2);
  max-width: 600px;
  text-shadow: 0 2px 10px rgba(255, 255, 255, 0.8);
}
.Homepage_hero__actions__mOsuX {
  display: flex;
  gap: 16px;
  margin-top: var(--space-lg);
  flex-wrap: wrap;
  justify-content: center;
}
.Homepage_hero__btn-primary__MX5we {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 28px;
  background: var(--color-ink);
  color: var(--color-paper);
  font-size: 1rem;
  font-weight: 500;
  border-radius: 9999px; /* Pill */
  text-decoration: none;
  transition: all 0.2s ease;
  min-width: 160px; /* Ensures both are equal size if text differs */
}
.Homepage_hero__btn-primary__MX5we:hover {
  background: var(--color-accent);
  color: var(--color-paper);
  transform: translateY(-2px);
}

/* ═══════════════════════════════════════════════════════
   SECTION 2: VIDEO
   ═══════════════════════════════════════════════════════ */
.Homepage_video-section__WbZLq {
  padding: 100px 24px;
  background: var(--color-paper);
}
.Homepage_video-section__container__KZo5W {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}
.Homepage_video-section__player-wrapper__TuAGd {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-rule);
  margin-top: var(--space-xl);
  position: relative;
  background: var(--color-paper-2);
}
.Homepage_video-section__player__Fdm4w {
  position: absolute;
  top: 0;
  left: 0;
}
.Homepage_video-section__overlay__-wvKH {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  transition: background 0.3s ease;
}
.Homepage_video-section__overlay__-wvKH:hover {
  background: rgba(0, 0, 0, 0.2);
}
.Homepage_video-section__play-btn__XT3i9 {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(233, 69, 96, 0.9);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 30px rgba(233, 69, 96, 0.4);
  pointer-events: none; /* Let clicks pass to the overlay */
  /* Make sure the icon is perfectly centered */
}
.Homepage_video-section__play-btn__XT3i9 svg {
  margin-left: 4px;
}

/* ═══════════════════════════════════════════════════════
   SECTION 3: PRODUCTS
   ═══════════════════════════════════════════════════════ */
.Homepage_products__me95R {
  padding: 100px 24px;
  background: var(--color-paper);
}
.Homepage_products__container__eUMjc {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}
.Homepage_products__grid__fElAD {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  width: 100%;
  margin-top: 24px;
}

.Homepage_product-card__Vhvp7 {
  display: flex;
  flex-direction: column;
  background: var(--color-paper);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--color-rule);
  transition: all 0.3s ease;
}
.Homepage_product-card__Vhvp7:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.04);
  border-color: var(--color-rule-2, var(--color-rule));
}
.Homepage_product-card__image-wrapper__VwUGA {
  position: relative;
  width: 100%;
  aspect-ratio: 16/10;
  overflow: hidden;
  background: var(--color-paper-2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid var(--color-rule);
}
.Homepage_product-card__image__6UjlT {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid var(--color-rule);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.4s ease;
}
.Homepage_product-card__Vhvp7:hover .Homepage_product-card__image__6UjlT {
  transform: scale(1.02);
}
.Homepage_product-card__image-overlay__XN6jd {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
  display: flex;
  justify-content: flex-end;
}
.Homepage_product-card__badge-explore__zkJlI, .Homepage_product-card__badge-profile__s89LG {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #ffffff;
}
.Homepage_product-card__badge-explore__zkJlI {
  background: var(--accent-color);
}
.Homepage_product-card__badge-profile__s89LG {
  background: var(--public-profile-color);
}
.Homepage_product-card__body__M5YBK {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Homepage_product-card__title__w8L2n {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-ink);
}
.Homepage_product-card__icon-explore__yp-9i, .Homepage_product-card__icon-profile__mhDJZ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: var(--color-paper-2);
  color: var(--color-ink);
  border: 1px solid var(--color-rule);
  flex-shrink: 0;
}
.Homepage_product-card__description__fZQN2 {
  font-size: 0.95rem;
  color: var(--color-ink-2);
  line-height: 1.6;
}
.Homepage_product-card__features__MYJ3L {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  margin: 12px 0;
}
.Homepage_product-card__feature__W8HVX {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;
  color: var(--color-ink);
  font-weight: 400;
}
.Homepage_product-card__feature-icon__s0LA2 {
  display: flex;
  align-items: center;
  color: var(--color-accent);
  opacity: 0.9;
}
.Homepage_product-card__feature-icon__s0LA2 svg {
  width: 18px;
  height: 18px;
}
.Homepage_product-card__cta-explore__\\+uupE, .Homepage_product-card__cta-profile__flHuh {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 9999px; /* Pill */
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-top: 12px;
  background: transparent;
  color: var(--color-ink);
  border: 1px solid var(--color-rule);
}
.Homepage_product-card__cta-explore__\\+uupE:hover, .Homepage_product-card__cta-profile__flHuh:hover {
  background: var(--color-paper-2);
  border-color: var(--color-ink-2);
  transform: translateX(4px);
}

/* ═══════════════════════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════════════════════ */
@media only screen and (max-width: 1024px) {
  .Homepage_products__grid__fElAD {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media only screen and (max-width: 768px) {
  .Homepage_hero__title__gCViv {
    font-size: 2.2rem;
  }
  .Homepage_hero__subtitle__7BKto {
    font-size: 1.05rem;
  }
  .Homepage_hero__content__5J5M7 {
    padding: 100px 20px 60px;
  }
  .Homepage_section-title__MKa30 {
    font-size: 2rem;
  }
  .Homepage_video-section__WbZLq,
  .Homepage_products__me95R {
    padding: 64px 16px;
  }
}
@media only screen and (max-width: 480px) {
  .Homepage_hero__title__gCViv {
    font-size: 1.8rem;
  }
  .Homepage_hero__subtitle__7BKto {
    font-size: 0.95rem;
  }
  .Homepage_hero__actions__mOsuX {
    flex-direction: column;
    width: 100%;
  }
  .Homepage_hero__actions__mOsuX a {
    justify-content: center;
    width: 100%;
  }
  .Homepage_hero__badge-logo__L\\+0bg {
    height: 40px;
  }
  .Homepage_section-title__MKa30 {
    font-size: 1.6rem;
  }
  .Homepage_section-subtitle__v6H8o {
    font-size: 1rem;
  }
  .Homepage_product-card__body__M5YBK {
    padding: 20px;
  }
  .Homepage_product-card__title__w8L2n {
    font-size: 1.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/LandingPage/Pages/Homepage/Homepage.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;EAAA;AAMA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA,sCAAA;AACA;EACE,wCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;;4DAAA;AAGA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,6BAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA;;;GAAA;EAIA,oCAAA;EACA,YAAA;EACA,UAAA;AACJ;AAEE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AADJ;AAIE;EACE,YAAA;EACA,kFAAA;AAFJ;AAKE;EACE,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mFAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gDAAA;AAJJ;AAOE;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,uBAAA;AALJ;AAQE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA,EAAA,SAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA,EAAA,gDAAA;AANJ;AAQI;EACE,+BAAA;EACA,yBAAA;EACA,2BAAA;AANN;;AAWA;;4DAAA;AAGA;EACE,mBAAA;EACA,8BAAA;AARF;AAUE;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AARJ;AAWE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gCAAA;AATJ;AAYE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAVJ;AAaE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;AAXJ;AAaI;EACE,8BAAA;AAXN;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,6CAAA;EACA,oBAAA,EAAA,mCAAA;EAEA,6CAAA;AAdJ;AAeI;EACE,gBAAA;AAbN;;AAkBA;;4DAAA;AAGA;EACE,mBAAA;EACA,8BAAA;AAfF;AAiBE;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;AAjBF;AAmBE;EACE,2BAAA;EACA,2CAAA;EACA,oDAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0CAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,0CAAA;EACA,+BAAA;AAnBJ;AAsBE;EACE,sBAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,4DAAA;EACA,aAAA;EACA,yBAAA;AArBJ;AAwBE;EAEE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,+BAAA;AAxBJ;AA2BE;EACE,uCAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AA3BJ;AA8BE;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,uBAAA;EACA,mCAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,YAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,YAAA;AAjCN;AAqCE;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA,EAAA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mCAAA;AApCJ;AAuCE;EAEE,gCAAA;EACA,gCAAA;EACA,0BAAA;AAtCJ;;AAyCA;;4DAAA;AAGA;EACE;IACE,0BAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAtCF;AACF;AAyCA;EAEI;IACE,iBAAA;EAxCJ;EA0CE;IACE,kBAAA;EAxCJ;EA0CE;IACE,wBAAA;EAxCJ;EA4CA;IACE,eAAA;EA1CF;EA6CA;;IAEE,kBAAA;EA3CF;AACF;AA8CA;EAEI;IACE,iBAAA;EA7CJ;EA+CE;IACE,kBAAA;EA7CJ;EA+CE;IACE,sBAAA;IACA,WAAA;EA7CJ;EA+CI;IACE,uBAAA;IACA,WAAA;EA7CN;EAgDE;IACE,YAAA;EA9CJ;EAkDA;IACE,iBAAA;EAhDF;EAmDA;IACE,eAAA;EAjDF;EAoDA;IACE,aAAA;EAlDF;EAqDA;IACE,iBAAA;EAnDF;AACF","sourcesContent":["/* Hallmark · genre: modern-minimal · macrostructure: Marquee Hero · theme: custom\n * paper: oklch(98% 0.010 250) · accent: oklch(60% 0.15 250)\n * display: Inter · body: Inter · axes: light / geometric-sans / cool\n * studied: no · context: inferred · v1.1.0\n */\n\n.homepage {\n  width: 100%;\n  overflow-x: clip;\n}\n\n/* ─── Shared section typography ─── */\n.section-title {\n  font-size: clamp(2rem, 4vw + 1rem, 3rem);\n  font-weight: 600;\n  color: var(--color-ink);\n  text-align: center;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n}\n\n.section-subtitle {\n  font-size: 1.125rem;\n  color: var(--color-ink-2);\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* ═══════════════════════════════════════════════════════\n   SECTION 1: HERO\n   ═══════════════════════════════════════════════════════ */\n.hero {\n  position: relative;\n  width: 100%;\n  min-height: 80vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-paper);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  padding-top: var(--space-4xl);\n\n  &__overlay {\n    position: absolute;\n    inset: 0;\n    /* \n      Reduced opacity to show more of the image, \n      while still keeping enough contrast for the text.\n    */\n    background-color: var(--color-paper);\n    opacity: 0.70;\n    z-index: 1;\n  }\n\n  &__content {\n    position: relative;\n    z-index: 2;\n    max-width: 880px;\n    padding: 120px 24px 80px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: var(--space-xl);\n  }\n\n  &__badge {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: var(--space-sm);\n  }\n\n  &__badge-logo {\n    height: 48px;\n    /* Removed brightness invert so logo shows in its original colors on white paper */\n  }\n\n  &__title {\n    font-size: clamp(3rem, 6vw + 1rem, 5rem);\n    font-weight: 700;\n    line-height: 1.1;\n    letter-spacing: -0.04em;\n    color: var(--color-ink);\n    text-shadow: 0 4px 20px rgba(255, 255, 255, 0.8), 0 0 40px rgba(255, 255, 255, 0.6);\n  }\n\n  &__subtitle {\n    font-size: 1.25rem;\n    line-height: 1.6;\n    color: var(--color-ink-2);\n    max-width: 600px;\n    text-shadow: 0 2px 10px rgba(255, 255, 255, 0.8);\n  }\n\n  &__actions {\n    display: flex;\n    gap: 16px;\n    margin-top: var(--space-lg);\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  &__btn-primary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 28px;\n    background: var(--color-ink);\n    color: var(--color-paper);\n    font-size: 1rem;\n    font-weight: 500;\n    border-radius: 9999px; /* Pill */\n    text-decoration: none;\n    transition: all 0.2s ease;\n    min-width: 160px; /* Ensures both are equal size if text differs */\n\n    &:hover {\n      background: var(--color-accent);\n      color: var(--color-paper);\n      transform: translateY(-2px);\n    }\n  }\n}\n\n/* ═══════════════════════════════════════════════════════\n   SECTION 2: VIDEO\n   ═══════════════════════════════════════════════════════ */\n.video-section {\n  padding: 100px 24px;\n  background: var(--color-paper);\n\n  &__container {\n    max-width: 960px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    align-items: center;\n  }\n\n  &__player-wrapper {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 20px 40px -10px rgba(0,0,0,0.1);\n    border: 1px solid var(--color-rule);\n    margin-top: var(--space-xl);\n    position: relative;\n    background: var(--color-paper-2);\n  }\n\n  &__player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  &__overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    z-index: 10;\n    transition: background 0.3s ease;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  &__play-btn {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: rgba(233, 69, 96, 0.9);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 30px rgba(233, 69, 96, 0.4);\n    pointer-events: none; /* Let clicks pass to the overlay */\n    \n    /* Make sure the icon is perfectly centered */\n    svg {\n      margin-left: 4px;\n    }\n  }\n}\n\n/* ═══════════════════════════════════════════════════════\n   SECTION 3: PRODUCTS\n   ═══════════════════════════════════════════════════════ */\n.products {\n  padding: 100px 24px;\n  background: var(--color-paper);\n\n  &__container {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    align-items: center;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 32px;\n    width: 100%;\n    margin-top: 24px;\n  }\n}\n\n.product-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--color-paper);\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--color-rule);\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.04);\n    border-color: var(--color-rule-2, var(--color-rule));\n  }\n\n  &__image-wrapper {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16 / 10;\n    overflow: hidden;\n    background: var(--color-paper-2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    border-bottom: 1px solid var(--color-rule);\n  }\n\n  &__image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 6px;\n    border: 1px solid var(--color-rule);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    transition: transform 0.4s ease;\n  }\n\n  &:hover &__image {\n    transform: scale(1.02);\n  }\n\n  &__image-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 16px 20px;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  &__badge-explore,\n  &__badge-profile {\n    padding: 6px 16px;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #ffffff;\n  }\n\n  &__badge-explore {\n    background: var(--accent-color);\n  }\n\n  &__badge-profile {\n    background: var(--public-profile-color);\n  }\n\n  &__body {\n    padding: 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: var(--color-ink);\n  }\n\n  &__icon-explore,\n  &__icon-profile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 6px;\n    background: var(--color-paper-2);\n    color: var(--color-ink);\n    border: 1px solid var(--color-rule);\n    flex-shrink: 0;\n  }\n\n  &__description {\n    font-size: 0.95rem;\n    color: var(--color-ink-2);\n    line-height: 1.6;\n  }\n\n  &__features {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 0;\n    margin: 12px 0;\n  }\n\n  &__feature {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 0.9rem;\n    color: var(--color-ink);\n    font-weight: 400;\n  }\n\n  &__feature-icon {\n    display: flex;\n    align-items: center;\n    color: var(--color-accent);\n    opacity: 0.9;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  &__cta-explore,\n  &__cta-profile {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 24px;\n    border-radius: 9999px; /* Pill */\n    font-size: 0.95rem;\n    font-weight: 500;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    align-self: flex-start;\n    margin-top: 12px;\n    background: transparent;\n    color: var(--color-ink);\n    border: 1px solid var(--color-rule);\n  }\n\n  &__cta-explore:hover,\n  &__cta-profile:hover {\n    background: var(--color-paper-2);\n    border-color: var(--color-ink-2);\n    transform: translateX(4px);\n  }\n}\n/* ═══════════════════════════════════════════════════════\n   RESPONSIVE\n   ═══════════════════════════════════════════════════════ */\n@media only screen and (max-width: 1024px) {\n  .products__grid {\n    grid-template-columns: 1fr;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .hero {\n    &__title {\n      font-size: 2.2rem;\n    }\n    &__subtitle {\n      font-size: 1.05rem;\n    }\n    &__content {\n      padding: 100px 20px 60px;\n    }\n  }\n\n  .section-title {\n    font-size: 2rem;\n  }\n\n  .video-section,\n  .products {\n    padding: 64px 16px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .hero {\n    &__title {\n      font-size: 1.8rem;\n    }\n    &__subtitle {\n      font-size: 0.95rem;\n    }\n    &__actions {\n      flex-direction: column;\n      width: 100%;\n\n      a {\n        justify-content: center;\n        width: 100%;\n      }\n    }\n    &__badge-logo {\n      height: 40px;\n    }\n  }\n\n  .section-title {\n    font-size: 1.6rem;\n  }\n\n  .section-subtitle {\n    font-size: 1rem;\n  }\n\n  .product-card__body {\n    padding: 20px;\n  }\n\n  .product-card__title {\n    font-size: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homepage": `Homepage_homepage__qOb6-`,
	"section-title": `Homepage_section-title__MKa30`,
	"section-subtitle": `Homepage_section-subtitle__v6H8o`,
	"hero": `Homepage_hero__8g5F3`,
	"hero__overlay": `Homepage_hero__overlay__RO0t1`,
	"hero__content": `Homepage_hero__content__5J5M7`,
	"hero__badge": `Homepage_hero__badge__DxPes`,
	"hero__badge-logo": `Homepage_hero__badge-logo__L+0bg`,
	"hero__title": `Homepage_hero__title__gCViv`,
	"hero__subtitle": `Homepage_hero__subtitle__7BKto`,
	"hero__actions": `Homepage_hero__actions__mOsuX`,
	"hero__btn-primary": `Homepage_hero__btn-primary__MX5we`,
	"video-section": `Homepage_video-section__WbZLq`,
	"video-section__container": `Homepage_video-section__container__KZo5W`,
	"video-section__player-wrapper": `Homepage_video-section__player-wrapper__TuAGd`,
	"video-section__player": `Homepage_video-section__player__Fdm4w`,
	"video-section__overlay": `Homepage_video-section__overlay__-wvKH`,
	"video-section__play-btn": `Homepage_video-section__play-btn__XT3i9`,
	"products": `Homepage_products__me95R`,
	"products__container": `Homepage_products__container__eUMjc`,
	"products__grid": `Homepage_products__grid__fElAD`,
	"product-card": `Homepage_product-card__Vhvp7`,
	"product-card__image-wrapper": `Homepage_product-card__image-wrapper__VwUGA`,
	"product-card__image": `Homepage_product-card__image__6UjlT`,
	"product-card__image-overlay": `Homepage_product-card__image-overlay__XN6jd`,
	"product-card__badge-explore": `Homepage_product-card__badge-explore__zkJlI`,
	"product-card__badge-profile": `Homepage_product-card__badge-profile__s89LG`,
	"product-card__body": `Homepage_product-card__body__M5YBK`,
	"product-card__title": `Homepage_product-card__title__w8L2n`,
	"product-card__icon-explore": `Homepage_product-card__icon-explore__yp-9i`,
	"product-card__icon-profile": `Homepage_product-card__icon-profile__mhDJZ`,
	"product-card__description": `Homepage_product-card__description__fZQN2`,
	"product-card__features": `Homepage_product-card__features__MYJ3L`,
	"product-card__feature": `Homepage_product-card__feature__W8HVX`,
	"product-card__feature-icon": `Homepage_product-card__feature-icon__s0LA2`,
	"product-card__cta-explore": `Homepage_product-card__cta-explore__+uupE`,
	"product-card__cta-profile": `Homepage_product-card__cta-profile__flHuh`
};
export default ___CSS_LOADER_EXPORT___;
